import Button from "@/common/components/Button";
import { LucideIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface CompanyMaintenanceGridCardProps {
  Icon: LucideIcon;
  label: string;
  linkTo: string;
  operationKlassToCheckPermission?: string;
}

const CompanyMaintenanceGridCard = ({ Icon, label, linkTo, operationKlassToCheckPermission }: CompanyMaintenanceGridCardProps) => {
  const navigate = useNavigate();

  return (
    <Button
      className="bg-blue-200 hover:bg-blue-300 h-40 w-full transition-colors cursor-pointer p-4 flex flex-col items-start text-start gap-y-8 rounded-lg shadow-xl relative"
      operationKlassToCheckPermission={operationKlassToCheckPermission}
      noPermissionBehavior="hide"
      onClick={() => navigate(linkTo)}
    >
      <Icon strokeWidth={1} size={64} />

      <p className="text-base font-bold">
        {label}
      </p>
    </Button>
  );
}

export default CompanyMaintenanceGridCard;
